angular.module("acl.visualizer.quickMenu", [
  "acl.common.event",
  "acl.visualizer.checkboxFilter",
  "acl.visualizer.conditionalFormatting",
  "acl.visualizer.criteriaFilter",
  "acl.visualizer.fieldFormatOptions",
  "acl.visualizer.valueFilter",
]);
